<h1 mat-dialog-title>
    Create Prompt
</h1>
<div>
    <button class="start-button" *ngIf="!isRecording && !blobUrl" (click)="startRecording()">Start Recording</button>
    <button class="stop-button" *ngIf="isRecording && !blobUrl" (click)="stopRecording()">Stop Recording</button>
    <button class="cancel-button" *ngIf="!isRecording && blobUrl" (click)="clearRecordedData()">Clear Recording</button>
    <div *ngIf="isRecording && !blobUrl"> {{recordedTime}} </div>
    <div>
        <audio *ngIf="!isRecording && blobUrl"  controls>
            <source [src]="blobUrl" type="audio/webm">
        </audio>
    </div>
</div>
<mat-dialog-actions>
    <button class="mat-raised-button" (click)="onDismiss()">Cancel</button>
    <button class="mat-raised-button mat-primary" (click)="onConfirm()">Save File</button>
</mat-dialog-actions>